import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IAiActions, IThunkGetAiModels } from '../types';

const onGetAiModels: IThunkGetAiModels = thunk(async ({ setAiModels }: Actions<IAiActions>) => {
  const data = await api.ai.getAiModels().then(r => r.data);

  setAiModels(data);
});

// eslint-disable-next-line import/no-unused-modules -- used in thunks/index.ts
export default onGetAiModels;
